import tableAppCategories from './tableRelatedAppCategories';
import tableYoutubeCategory from './tableRelatedYoutubeCategories';

export default {
  title: 'Youtube Categories',
  attributeName: 'youtubeCategory',
  //getURL: 'mainHubId/configId/appCategory',
  getURL:'mainHubs/{mainHubId}/youtube/categories',
  createURL: '',
  updateURL: '',
  removeURL: '',
  itemName: 'name',
  itemId: 'id',
  sessionParams: ['mainHubId', 'configId'],
  tableConfig: tableYoutubeCategory,
};
